import authRequest from "../utils/authRequest";

const baseUrl = "/sop-content";
import axios from "axios";

export interface SOPCopyItem {
  id: string;
  output: Object;
  generation_id: string;
  is_saved?: boolean;
  rating?: number;
}

export interface SOPCopyResult {
  input_data: Object;
  output_data: Array<SOPCopyItem>;
}

export const reviewSop = (
  formData: FormData,
  sopId: string,
  sop_type: string
) => {
  return new Promise<any>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/getSopReview`,
      method: "post",
      data: formData,
      params: {
        sop_id: sopId,
        sop_type: sop_type,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};
export const getImprovedText = (
  formData: FormData,
  sopId: string,
  sop_type: string
) => {
  return new Promise<any>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/getImprovedText`,
      method: "post",
      data: formData,
      params: {
        sop_id: sopId,
        sop_type: sop_type,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

export const getRejectionLetterResponse = (
  formData: FormData,
  sopId: string,
  sop_type: string
) => {
  return new Promise<any>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/getRejectionLetterResponse`,
      method: "post",
      data: formData,
      params: {
        sop_id: sopId,
        sop_type: sop_type,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};
export const regenerateRejectionLetterResponse = (
  instructions: string,
  sopId: string
) => {
  return new Promise<any>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/regenerateRejectionResponseLetter`,
      method: "get",

      params: {
        instructions: instructions,
        history_id: sopId,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};
export const generateContent = (
  endpoint: string,
  data: Object,
  historyId: string,
  sop_type: string,
  size: string
) => {
  return new Promise<SOPCopyResult>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/${endpoint}`,
      method: "post",
      data: data,
      params: {
        history_id: historyId,
        sop_type: sop_type,
        size: size,
      },
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};

interface SERPAssitantResult {
  output: string;
}

export const getSerpAssitance = (
  inputs: any,
  helpType: string,
  sopId: string,
  sopType: string
) => {
  return new Promise<SERPAssitantResult>((resolve, reject) => {
    authRequest({
      url: `${baseUrl}/serp-assistance`,
      method: "post",
      data: {
        inputs: inputs,
        help_type: helpType,
        sopId: sopId,
        sopType: sopType,
      },
    })
      .then((response) => {
        if (response && response.data) resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
};
